import React from "react";

const PageHeading = ({
	title,
	subtitle,
	children,
}: {
	title: string;
	subtitle?: string | null;
	children?: React.ReactNode;
}) => (
	<>
		<h1 className="to-lg:w-4/5 -ml-1 whitespace-pre-wrap text-2xl leading-none lg:col-span-2 lg:text-4xl">{title}</h1>
		{subtitle && (
			<div className="col-start-3 mt-16 flex flex-col justify-between lg:mt-0">
				<p className="lg:text-xl">{subtitle}</p>
				{children}
			</div>
		)}
	</>
);

export default PageHeading;
